<template>
  <div>
    <!-- MAIN CONTENT -->
    <div style="overflow: auto;">
      <v-container pa-0>

        <v-layout align-center>

          <!-- select menu -->
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
              >
                <v-icon>mdi-check-box-multiple-outline</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
              @click="selectAll">
                <v-list-item-title>Select all</v-list-item-title>
              </v-list-item>
              <v-list-item
              @click="selectPage">
                <v-list-item-title>Select page</v-list-item-title>
              </v-list-item>
              <v-list-item
              @click="selectNone">
                <v-list-item-title>Select none</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-btn
          text
          color="text"
          @click="addItem">
          <v-icon>add</v-icon>
            Add
          </v-btn>

          <v-text-field
          v-model="searchText"
          solo
          placeholder="Search"
          color="text"
          hide-details
          clearable>

          </v-text-field>

          <!-- filter menu -->
          <v-menu 
          bottom
          left
          transition="slide-y-transition"
          offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                v-on="on"
              >
                <v-icon color="text">filter_list</v-icon>
                {{ sortOptions[sortIndex] }}
                <v-icon 
                small
                color="color1"
                :class="['sort-arrow visible transition2s', {'rotate': sortAscending}]">
                  arrow_downward
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-item-group 
              v-model="sortIndex"
              mandatory>
                <v-item
                  v-for="(n, index) in sortOptions"
                  :key="n">
                  <v-list-item
                    v-ripple
                    slot-scope="{ active }"
                    :selected="active"
                    @click="clickSortHeader(index)"
                  >
                    {{ n }}
                    <v-icon 
                    small
                    color="color1"
                    :class="['sort-arrow', {'rotate': active && sortAscending}, {'visible': active }]">
                      arrow_downward
                    </v-icon>
                  </v-list-item>
                </v-item>
              </v-item-group>
            </v-list>
          </v-menu>
          <!-- end filter menu -->
        </v-layout>

        <!-- Selected toolbar -->
        <c-transition-expand>
          <!-- selected count -->
          <div v-if="selectedCount > 0">
            <div
            class="c-flex-r1 align-center subheading color1 white--text">
              <v-btn
              icon
              class="ma-0"
              @click="selected = {}">
                <v-icon color="white">close</v-icon>
              </v-btn>
              <div class="text-sans font-weight-medium">
                <span>&nbsp;{{ selectedCount }}</span>
                selected 
              </div>
              <span class="ml-2">|</span>
              <v-btn 
              icon
              @click="onDelete">
                <v-icon color="white">delete_outline</v-icon>
              </v-btn>
              <!-- select menu -->
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    v-on="on"
                  >
                    <v-icon>mdi-check-box-multiple-outline</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                  @click="selectAll">
                    <v-list-item-title>Select all</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                  @click="selectPage">
                    <v-list-item-title>Select page</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                  @click="selectNone">
                    <v-list-item-title>Select none</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </c-transition-expand>
        <!-- end Selected toolbar -->

        <div class="c-hr"></div>

        <div>
          <tri-row
          v-for="(item, index) in paginatedArray" 
          :key="index" 
          :item="item"
          :vmode="1"
          :showRecipeErrors="showRecipeErrors"
          :inventoryView="inventoryView"
          :selected="selected"
          :searchText="searchText"
          :totalFilledDict="totalFilledDict"
          :totalInStock="totalInStockDict[item.definitionId]"
          :required="requiredDict[item.definitionId]"
          :percent="percentDict[item.definitionId]"
          @checkRow="checkRow(item)"
          @click.native="clickRow(item)"
          >
          </tri-row>
        </div>

        <!-- DEFAULT NO ITEM CARD -->
        <transition
        name="slide-y-transition"
        mode="out-in">
          <v-card v-if="(searchText || '').length > 0 && searchMatches.length === 0" 
          class="grey--text pa-2 ma-2 elevation-0"
          key="2">
            <v-layout align-center>
              <v-icon 
              color="grey"
              style="font-size: 4rem;">
                search
              </v-icon>
              No items match your search terms
            </v-layout>
          </v-card>
          <v-card v-else-if="items.length === 0" 
          class="grey--text pa-2 ma-2 elevation-0 text-xs-center"
          key="1">
            <v-layout align-center>
              <v-icon 
              color="grey"
              style="font-size: 4rem;">
                mdi-information-outline
              </v-icon>
              No items
            </v-layout>
          </v-card>
        </transition>
        <!-- DEFAULT NO ITEM CARD -->

        <div class="text-xs-center">
          <v-pagination
          v-if="paginationLength > 1"
          v-model="page"
          :length="paginationLength"
          circle>

          </v-pagination>

        </div>

      </v-container>

    </div>

    <!-- DIALOGS -->
    <c-select-inv-def-dialog ref="selectItemDialog" :exceptions="definitionIdArray">
    </c-select-inv-def-dialog>

    <!-- DIALOG -->
    <v-dialog
    v-model="rowDialog"
    persistent 
    scrollable
    transition="c-anim-slide-left-fade"
    :fullscreen="$vuetify.breakpoint.xs"
    content-class="c-dialog-border-13"
    max-width="400px">
      <v-card>
        <v-layout class="toolbar-pagetop c-flex-00a">
          <v-btn
          icon
          @click="closeRowEditDialog">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <div class="c-flex-r1 align-center text-sans font-weight-bold">
            Debit batches
          </div>
          <v-btn
          icon
          @click="updateRow">
            <v-icon>check</v-icon>
          </v-btn>
        </v-layout>
        <div style="overflow: auto;">
          <dialog-row
          :key="selectedItem.tempID" 
          :item="clonedRow"
          :inputs.sync="clonedInputs"
          :inventoryView="inventoryView"
          @selectDefinition="selectDefinition"
          >
          </dialog-row>
        </div>
      </v-card>
    </v-dialog>
    <!-- END DIALOG -->

  </div>
</template>

<script>
import ListController from '@/mixins/ListController'
import TriRow from './TriRow'
import DialogRow from './BatchDialog'
import Vue from 'vue'

export default {
  props: {
    inputs: {
      default: () => {} // {defId: {invId: quantity}
    },
    itemsSource: {
      default: () => []
    },
    requiredDict: {
      default: () => {}
    },
    quantity: null,
    inventoryView: {
      default: () => {}
    },
    totalFilledDict: {
      default: () => {}
    },
    showRecipeErrors: {
      default: true
    }
  },
  mixins: [ListController],
  components: {
    TriRow,
    DialogRow
  },
  data () {
    return {
      sortOptions: [
        'Name', 'Debit'
      ],
      sortIndex: 1,
      rowDialog: false,
      selectedItem: {},
      clonedRow: {},
      clonedInputs: {},
      sortLive: true
    }
  },
  computed: {
    totalInStockDict () {
      var dict = {}
      for (var item of this.items) {
        var inventory = Object.values(this.inventoryView).filter(invItem => invItem.inventory_item_id === item.definitionId)
        dict[item.definitionId] = inventory.reduce((a, b) => +a + +b.quantity, 0)
      }
      return dict
    },
    percentDict () {
      var dict = {}
      for (var item of this.items) {
        var totalInStock = this.totalInStockDict[item.definitionId]
        var filled = this.totalFilledDict[item.definitionId]
        var percent = 100 - (((totalInStock - filled) / totalInStock) * 100)
        percent = totalInStock === 0 ? 100 : percent
        dict[item.definitionId] = isNaN(percent) ? 0 : percent
      }
      return dict
    },
    definitionIdArray () {
      var retArray = new Set()
      for (var item of this.items) {
        retArray.add(item.definitionId)
      }
      if (this.selectedItem.definitionId) {
        retArray.delete(this.selectedItem.definitionId)
      }
      if (this.clonedRow.definitionId) {
        retArray.add(this.clonedRow.definitionId)
      }
      return Array.from(retArray)
    }
  },
  watch: {
    itemsSource: {
      immediate: true,
      handler (nv) {
        this.items = nv
      }
    },
    items (nv) {
      var currentIds = nv.map(item => String(item.definitionId))
      var inputIds = Object.keys(this.inputs)
      var missingIds = inputIds.filter((inputId) => {
        return !currentIds.includes(inputId)
      })
      missingIds.forEach(id => {
        Vue.delete(this.inputs, id)
      })
    }
  },
  methods: {
    addItem () {
      this.$refs.selectItemDialog.open()
        .then((selectedItem) => {
          this.items.push({
            definitionId: selectedItem.id
          })
        })
        .catch(() => {
          // console.log('rejected')
        })
    },
    closeRowEditDialog () {
      this.rowDialog = false
      // setting clonedRow to an empty object will cause the batches to collapse, so delay it untill
      // dialog close animation has finished
      setTimeout(() => {
        if (this.rowDialog === false) {
          this.selectedItem = {}
          this.clonedRow = {}
        }
      }, 350)
    },
    updateRow () {
      if (this.selectedItem.definitionId !== this.clonedRow.definitionId) {
        Vue.delete(this.inputs, this.selectedItem.definitionId)
      }
      Object.assign(this.selectedItem, this.clonedRow)
      // Object.assign(this.inputs, this.selectedItem.definitionId, this.clonedInputs)
      // this.inputs[this.selectedItem.definitionId] = this.clonedInputs
      Vue.set(this.inputs, this.selectedItem.definitionId, this.clonedInputs)
      this.closeRowEditDialog()
    },
    selectDefinition (item) {
      this.$refs.selectItemDialog.open()
        .then((selectedItem) => {
          item.definitionId = selectedItem.id
        })
        .catch(() => {
          // console.log('rejected')
        })
    },
    clickRow (item) {
      if (this.selectedCount > 0) {
        this.checkRow(item)
      } else {
        this.selectedItem = item
        this.clonedRow = JSON.parse(JSON.stringify(item))
        this.clonedInputs = JSON.parse(JSON.stringify(this.inputs[item.definitionId] || {}))
        this.rowDialog = true
      }
    },
    sort (headerIndex, items, sortAscending) {
      if (headerIndex === 0) { // item
        return items.sort((a, b) => {
          var defA = this.$store.state.db.inventoryDefinitions.definitions[a.definitionId]
          var defB = this.$store.state.db.inventoryDefinitions.definitions[b.definitionId]
          return sortAscending ? defA.name.localeCompare(defB.name) : defB.name.localeCompare(defA.name)
        })
      } else if (headerIndex === 1) { // percent
        return items.sort((a, b) => {
          return sortAscending ? this.percentDict[a.definitionId] - this.percentDict[b.definitionId] : this.percentDict[b.definitionId] - this.percentDict[a.definitionId]
        })
      }
      return items
    },
    search (items) {
      if ((this.searchText || '').length > 0) {
        var keywords = (this.searchText || '').toLowerCase().split(' ')
        items = items.filter(item => {
          var definition = this.$store.state.db.inventoryDefinitions.definitions[item.definitionId]
          return keywords.every(keyword => {
            return (definition.name.toLowerCase()).indexOf(keyword) > -1
          })
        })
      }
      return items
    },
    onDelete () {
      var selectedRows = this.getSelectedRows()
      var idArray = selectedRows.reduce((a, i) => {
        a.push(i.tempID)
        return a
      }, [])
      var title = 'Delete ' + idArray.length + ' item' + (idArray.length === 1 ? '' : 's') + '?'
      this.$root.$confirm(title, 'Are you sure?', { color: 'purple' }).then((confirm) => {
        if (confirm) {
          for (var i = this.items.length - 1; i >= 0; --i) {
            if (idArray.includes(this.items[i].tempID)) {
              this.items.splice(i, 1)
            }
          }
          this.onSuccessfullDelete()
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.sort-arrow {
  opacity: 0;

  &.visible {
    opacity: 1;
  }
  &.rotate {
    transform: rotate( -180deg );
  }
}
.flex-header {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 4px;

  &:hover {
    background: #f5f5f5;
  }
}
</style>
